import { useSubscriptionInfo, useUserInfo } from "@next-platform/client-common-core";

import PageMetaTags from "@/components/common/PageMetaTags";
import { ROUTES } from "@/constants";

import SubscriberPortal from "./components/SubscriberPortal";
import SubscriptionPlanPage from "./components/subscriptionPlan/SubscriptionPlanPage";

const SubscriptionPortal = () => {
  const { onlyUserId: userId } = useUserInfo();
  const { isOneTime } = useSubscriptionInfo();

  if (!userId) {
    return <PageMetaTags canonicalUrl={ROUTES.login} />;
  }

  if (isOneTime) {
    return <SubscriptionPlanPage />;
  }

  return (
    <>
      <div className="flex justify-center">
        <SubscriberPortal />
      </div>
    </>
  );
};

export default SubscriptionPortal;
